module.exports = __webpack_public_path__ + "static/media/flower_screenshot_ru.5443c699.png";